import { Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Button, HStack, Image, Text, VStack } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

import { RiWindowsFill } from "react-icons/ri";
import { PageTitle } from "../utils/PageTitle";
import { FaLinux } from "react-icons/fa";

export function Launcher() {
    const { t } = useTranslation();

    return (
        <Box>
            <Box position="relative" w="100%">
                <Image
                    src="/images/headings/heading-gamepad.jpg"
                    alt="heading-community"
                    w="100%"
                    h={{ base: 36, sm: 36, md: 56, lg: 72 }}
                    objectFit="cover"
                    objectPosition={"center center"}
                    shadow={"md"}
                />
                {/* original top={7} */}
                <Breadcrumb position="absolute" top={7} left={10} color={"white"}>
                    <BreadcrumbItem>
                        <BreadcrumbLink href="/">Garrigue Games</BreadcrumbLink>
                    </BreadcrumbItem>

                    <BreadcrumbItem fontWeight={"semibold"} isCurrentPage>
                        <BreadcrumbLink href="/launcher">Launcher</BreadcrumbLink>
                    </BreadcrumbItem>
                </Breadcrumb>
            </Box>

            <VStack maxW={1536} p={10} alignItems={"left"}>
                <PageTitle>Launcher</PageTitle>
                <Text marginBottom={5} fontSize="md">
                    {t("launcher.about")}
                </Text>
                <HStack flexWrap={"wrap"}>
                    <Button
                        leftIcon={<RiWindowsFill />}
                        as="a"
                        href="https://gitlab.fi.muni.cz/legtvar/lager/-/releases/permalink/latest/downloads/lager_win-x64.zip"
                    >
                        {t("launcher.dl-win")}
                    </Button>
                    <Button
                        leftIcon={<FaLinux />}
                        as="a"
                        href="https://gitlab.fi.muni.cz/legtvar/lager/-/releases/permalink/latest/downloads/lager_linux-x64.zip"
                    >
                        {t("launcher.dl-linux")}
                    </Button>
                </HStack>
            </VStack>
        </Box>
    );
}

export default Launcher;
